import React from "react";
import "./header.css";
import { NavLink, useNavigate } from "react-router-dom";
import { logOut } from "../../redux/authSlice";
import { useSelector, useDispatch } from "react-redux";
import { hasRole } from "../../utils/api";

export default function Header() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const employee = useSelector(state => state.auth?.employee);
    const canSee = (...roles) => hasRole(employee, ...roles);

    const handleLogout = () => {
        dispatch(logOut());
        navigate("/", { replace: true });
    };

    return (
        <header>
            <nav className="navbar">
                <img
                    className="logo-small"
                    src={`${process.env.PUBLIC_URL}/img/LogoImageSmall.png`}
                    alt="Logo Ashara Studios"
                />
                <ul className="menu">
                    <li>
                        <NavLink to="/Profile">Profile</NavLink>
                        <hr />

                    </li>
                    {canSee("hr") && (
                        <li>
                            <NavLink to="/Administrative">Administrative</NavLink>
                            <hr />

                        </li>
                    )}
                    {canSee("marketing") && (
                        <li>
                            <NavLink to="/Marketing">Marketing</NavLink>
                            <hr />

                        </li>
                    )}
                    {canSee("marketing") && (
                        <li>
                            <NavLink to="/NewsLetter">NewsLetter</NavLink>
                            <hr />

                        </li>
                    )}
                    {canSee("games") && (
                        <li>
                            <NavLink to="/Games">Games</NavLink>
                            <hr />

                        </li>
                    )}
                    <li className="menu-item-logout">
                        <button type="button" className="menu-logout" onClick={handleLogout}>Logout</button>
                        <hr />
                    </li>
                </ul>
            </nav>
        </header>
    );
}